module.exports = __webpack_public_path__ + "img/autobus.77a3c64d.jpg";